export interface RollbarConfig {
  accessToken: string;
  environment: string;
  enabled?: boolean;
  captureUncaught?: boolean;
  captureUnhandledRejections?: boolean;
}

export function getRollbarConfigFromEnv(): RollbarConfig {
  const enabled = process.env.REACT_APP_ROLLBAR_ENABLED === 'true';
  const accessToken = process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN || '';
  
  if (!enabled || !accessToken) {
    console.info('Rollbar is disabled or access token not configured');
  }
  
  return {
    accessToken,
    environment: process.env.REACT_APP_ROLLBAR_ENVIRONMENT || process.env.NODE_ENV || 'development',
    enabled,
    captureUncaught: true,
    captureUnhandledRejections: true,
  };
}
